<template>
    <nav v-if="itemsTotal > 0" aria-label="Page navigation">
        <ul class="pagination">
            <li class="page-item" :class="{ 'disabled': isFirst }">
                <a class="page-link" href="#page-1" @click="first" tabindex="-1">«</a>
            </li>
            <li class="page-item" :class="{ 'disabled': isFirst }">
                <a class="page-link" :href="`#page-${page - 1}`" @click="prev">{{ 'pagination.prev' | translate }}</a>
            </li>
            <li v-for="nextPage in pageRange" class="page-item"
                :class="{ 'active': nextPage === page }">
                <a class="page-link" :href="`#page-${nextPage}`" @click="page = nextPage">{{ nextPage }}</a>
            </li>
            <li class="page-item" :class="{ 'disabled': isLast }">
                <a class="page-link" :href="`#page-${page + 1}`" @click="next">{{ 'pagination.next' | translate }}</a>
            </li>
            <li class="page-item" :class="{ 'disabled': isLast }">
                <a class="page-link" :href="`#page-${maxPage}`" @click="last">»</a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: {
            itemsTotal: { // Total number of records.
                type: Number,
                required: true
            },
            itemsLimit: { // Number of items per page.
                type: Number,
                default: 3
            },
            initialPage: { // Start from this page.
                type: Number,
                default: 1
            },
            maxRange: { // Number of visible pages in navigation.
                type: Number,
                default: 3
            }
        },
        data() {
            return {
                page: this.initialPage,
            }
        },
        watch: {
            page() { // Notify parent that page has been changed.
                // @see https://vuejs.org/v2/guide/components-custom-events.html#sync-Modifier
                this.$emit('update:initial-page', this.page)
            }
        },
        computed: {
            isFirst() {
                return this.page === 1
            },
            isLast() {
                return this.page === this.maxPage
            },
            maxPage() {
                return Math.ceil(this.itemsTotal / this.itemsLimit)
            },
            pageRange() {
                const maxPage = this.maxPage;
                let range = this.maxRange;
                if (maxPage < range) {
                    range = maxPage
                }

                // Calculate the start page for relative to current one for the given range.
                const middle = Math.floor(range / 2);
                let startPage = 1;
                if (this.page > middle) {
                    startPage = this.page - middle;
                    if (startPage + range - 1 > maxPage) {
                        startPage = maxPage - range + 1
                    }
                }

                // Make array of page numbers for a given range.
                return Array.from((new Array(range)).keys(), x => x + startPage)
            }
        },
        methods: {
            first() {
                this.page = 1
            },
            prev() {
                if (this.page > 1) {
                    this.page -= 1;
                }
            },
            next() {
                if (this.page < this.maxPage) {
                    this.page += 1;
                }
            },
            last() {
                this.page = this.maxPage
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Pagination.vue